export const webdavState = {
    webdavLoginPassword: undefined,
    webdavLoginUsername: undefined,
};
